import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBrowserTabs: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBrowserTabs"><Path fillRule="evenodd" clipRule="evenodd" d="M22 20H2V4H22V20ZM5 9H11V7H5V9ZM12.5 7V9H15V7H12.5ZM16.5 9H19V7H16.5V9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBrowserTabs;
